import React, { useRef, useState, useEffect } from "react";
import "./Game.css";
import { SectionWrapper } from "../../hoc";
import TableOfContents from "../TableOfContents/TableOfContents.tsx";
import TocMobile from "../ToCTelephone/TocTelephone.tsx";
import TextGame from "./TextGame";
import { PacmanLoader } from "react-spinners"; // Import the spinner component from react-spinners
import { gsap } from "gsap";
import { scrollToId } from "../../utils/scrollToId";

function Game({setDisplayNavBar}) {
  const [loading, setLoading] = useState(true); // State variable to control loading
  const headingsData = [
    {
      level: 2,
      text: "Introduction",
      id: "Introduction",
    },
    {
      level: 2,
      text: "Design choices",
      id: "Design",
    },
    {
      level: 2,
      text: "Main Game",
      id: "Main Game",
    },
    {
      level: 2,
      text: "Mini-Games",
      id: "Mini-Games",
    },
    {
      level: 2,
      text: "Collaboration",
      id: "Collaboration",
      },
      {
          level: 2,
          text: "Download",
          id: "Download",
      },
      {
        level: 2,
        text: "References",
        id: "references",
    }
  ];

  let tl = gsap.timeline();
  let tl2 = gsap.timeline();
  let cursor = useRef(null);
  let posX = 0;
  let posY = 0;
  let mouseX = 0;
  let mouseY = 0;

  tl.to({}, 0.016, {
    repeat: -1,
    onRepeat: function () {
      posX += (mouseX - posX) / 10;
      posY += (mouseY - posY) / 10;
      tl.set(cursor, {
        css: {
          left: posX - 50,
          top: posY - 50,
        },
      });
    },
  });
  tl2.from(
    cursor,
    {
      duration: 1.5,
      delay: 1,
      opacity: 0,
    },
    "-=1"
  );

  const handleMouseMove = (e) => {
    mouseX = e.pageX;
    mouseY = e.pageY;
  };

  document.addEventListener("mousemove", handleMouseMove);

  useEffect(() => {
    // Simulate a delay (remove this in your actual implementation)
    setTimeout(() => {
      setLoading(false); // Set loading to false after a delay
    }, 2000); // Simulated delay of 2 seconds

    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setDisplayNavBar(!loading)
    if(!loading){
      scrollToId()
    }
  }, [loading, setDisplayNavBar])

  return (
    <div className="relative">
      {loading ? (<div className="spinner-container fixed h-screen w-screen bg-white z-10">
          <PacmanLoader color="#BA55D3" loading={loading} />{" "}
          <script>{document.body.style.overflow = 'hidden'}</script>
        </div>): <script>{document.body.style.overflow = 'auto'}</script>}
        <>
          <div className="cursor-follow" ref={(el) => (cursor = el)}></div>
          <div className="top-page">
            <h1>Video Game</h1>
          </div>
          <div></div>
          <div
            className="grid grid-cols-12 gap-4"
            style={{ marginRight: "50px", marginLeft: "50px" }}
          >
            <div className="hidden md:block col-span-4 ml-6 order-2 md:order-1">
              <div className="sticky top-4 scrollable">
                <TableOfContents headings={headingsData} />
              </div>
            </div>
            <main className="prose col-span-12 md:col-span-8 order-1 md:order-2">
              <TextGame />
            </main>

            <div className="md:hidden col-span-12 order-3 TOCstyle">
              <TocMobile headings={headingsData} />
            </div>
          </div>
        </>
    </div>
  );
}

export default SectionWrapper(Game, "Game");
